import { fromJS } from 'immutable';

import {
	FETCH_REFERRER_PATIENTS,
	FETCH_REFERRER_PATIENTS_SUCCESS,
	FETCH_REFERRER_PATIENTS_ERROR,
	FETCH_REFERRER_PENDING,
	FETCH_REFERRER_PENDING_SUCCESS,
	FETCH_REFERRER_PENDING_ERROR,
} from './constants';

const initialState = fromJS({
	patients: [],
	patientsTotal: 0,
	patientsPage: 1,
	patientsLoading: false,
	pending: [],
	pendingLoading: false,
});

function referrerDashboardReducer(state = initialState, action) {
	switch (action.type) {
		case FETCH_REFERRER_PATIENTS:
			return state.set('patientsLoading', true);
		case FETCH_REFERRER_PATIENTS_SUCCESS:
			return state
				.set('patients', fromJS(action.data.patients || []))
				.set('patientsTotal', action.data.total || 0)
				.set('patientsPage', action.data.page || 1)
				.set('patientsLoading', false);
		case FETCH_REFERRER_PATIENTS_ERROR:
			return state.set('patientsLoading', false);
		case FETCH_REFERRER_PENDING:
			return state.set('pendingLoading', true);
		case FETCH_REFERRER_PENDING_SUCCESS:
			return state
				.set('pending', fromJS(action.data.pending || []))
				.set('pendingLoading', false);
		case FETCH_REFERRER_PENDING_ERROR:
			return state.set('pendingLoading', false);
		default:
			return state;
	}
}

export default referrerDashboardReducer;
